import script from "./DecessosRepository.vue?vue&type=script&lang=js"
export * from "./DecessosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__